import { getUUID } from '@/utils/utils'

// 获取提交数据
export default ({ quickSearchName, queryFields, sortValues }: any) => {
    const comFields = queryFields?.reduce((t, c) => {
        if (Array.isArray(c.fields)) {
            c.fields.forEach(v => {
                if (v.displayValue) {
                    t[v.name] = {
                        name: v.name,
                        value: v.value,
                        displayValue: v.displayValue
                    }
                }
            })
        }

        return t
    }, {})

    return {
        key: getUUID(),
        selectName: quickSearchName,
        fields: comFields,
        sortFields: sortValues
    }
}
